import React, { useContext, useEffect, useState } from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import ViewExistingPPT from "../../components/ExpertDetails/ViewExistingPPT";
import { UrlContext } from "../../contexts/UrlContext";
import { UserContext } from "../../contexts/UserContext";
import ViewApplication from "./ViewApplication";

export default function ExpertProjectInfo({ id, expertName }) {
  const [additionalList, setAdditionalList] = useState(null);
  const [inPerticipatedList, setInPerticipatedList] = useState(null);
  const [inInterestedList, setInInterestedList] = useState(null);
  const [addedInProjectList, setAddedInProjectList] = useState(null);
  const [createdPPTList, setCreatedPPTList] = useState(null);
  const [createdDigital, setCreatedDigital] = useState(null);
  const { API_URL } = useContext(UrlContext);
  const { userData } = useContext(UserContext);
  const [openProject, setOpenProject] = useState(null);
  const [isViewApplication, setIsViewApplication] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}expert-details-additional/` + id;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setInPerticipatedList(data.inPerticipatedList);
        setInInterestedList(data.inInterestedList);
        setAddedInProjectList(data.inProjectList);
        setAdditionalList(data);
        setCreatedPPTList(data.pEx_expert);
        setCreatedDigital(data.digitalCreated);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  const handleClosing = () => {
    setSelectedProject(null);
    setIsViewApplication(false);
  };

  return (
    <>
      {additionalList ? (
        <>
          {/* ------------------Participated in project list----------------- */}
          <div className="relative bg-white rounded-xl shadow p-6">
            <div
              className="absolute top-0 right-0 w-8 h-8 bg-[#365561] text-white text-xs font-bold flex items-center justify-center"
              style={{
                borderTopRightRadius: '19px',
                borderBottomLeftRadius: '50px',
              }}
            >
              <p className="text-white text-[10px] ml-1 -mt-1">EPH</p>
            </div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Participated in Projects</h2>
            </div>

            {inPerticipatedList?.length > 0 ? (
              <ul className="space-y-1">
                {inPerticipatedList.map((project, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="p-2 rounded-md hover:bg-gray-100 transition duration-150"
                    >
                      {/* Project Header */}
                      <div className="flex justify-between items-start flex-wrap gap-2">
                        <div className="flex-1">
                          <a
                            href={`/app/ProjectDetails/${project.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-sm sm:text-base font-medium text-[#365561] hover:underline"
                          >
                            {project.zoho_id} - {project.name}
                          </a>
                          <div className="mt-1 text-xs text-gray-500">
                            <strong>Consultant Rate:</strong> {project.con_rate} |{" "}
                            <strong>EPH Rate:</strong> {project.eph_rate}
                            {project.selfApplied && (<span className="ml-2 text-xs text-[#365561] font-semibold px-2 py-1 bg-gray-200 rounded-full">Self Applied</span>)}
                          </div>
                        </div>

                        <div className="text-sm text-center flex-shrink-0">
                          {project.proj_type === "exp" && (
                            <div className="text-xs text-gray-600">
                              <i className="fa-solid fa-phone-volume mr-1 text-sm" />
                              Expert Call
                            </div>
                          )}
                          <a
                            href={`/app/ProjectInformation/${project.id}/${id}/0/1`}
                            className="text-xs text-gray-500 hover:underline block mt-1"
                          >
                            {project.proj_start} - {project.proj_end}
                          </a>
                        </div>

                        {project.extensions.length > 0 && (
                          <button
                            className="text-gray-500 hover:text-gray-700"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenProject(openProject === project.id ? null : project.id);
                            }}
                          >
                            <i className={`fa fa-arrow-${openProject === project.id ? "up" : "down"}`} />
                          </button>
                        )}
                      </div>

                      {/* Extensions */}
                      {openProject === project.id && project.extensions.length > 0 && (
                        <div className="mt-3 border-l-4 border-gray-200 pl-4 bg-gray-50 rounded-md text-xs text-gray-600 space-y-2">
                          {project.extensions.map((ext, i) => (
                            <div key={i} className="flex flex-wrap gap-4">
                              <span>
                                <strong>Consultant Rate:</strong> {ext.con_rate}
                              </span>
                              <span>
                                <strong>EPH Rate:</strong> {ext.eph_rate}
                              </span>
                              <span>
                                <strong>Start:</strong> {ext.project_start}
                              </span>
                              <span>
                                <strong>End:</strong> {ext.project_end}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {i !== inPerticipatedList.length - 1 && (
                      <hr className="mt-1 mb-1 border-t border-gray-200" />
                    )}
                  </React.Fragment>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-500">No project found.</p>
            )}
          </div>



          {/* ---------------Interested in project list----------------- */}
          <div className="relative bg-white rounded-xl shadow p-6">
            <div
              className="absolute top-0 right-0 w-8 h-8 bg-[#365561] text-white text-xs font-bold flex items-center justify-center"
              style={{
                borderTopRightRadius: '19px',
                borderBottomLeftRadius: '50px',
              }}
            >
              <p className="text-white text-[10px] ml-1 -mt-1">EPH</p>
            </div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Interested in Projects</h2>
            </div>

            {inInterestedList?.length > 0 ? (
              <ul className="space-y-1">
                {inInterestedList.map((project, i) => (
                  <React.Fragment key={i}>
                    <div 
                      className={`p-2 rounded-md hover:bg-gray-100 transition duration-150 group ${project.isDeleted || project.rejected ? 'cursor-pointer' : null}`}
                      onClick={() => {
                        if (project.isDeleted || project.rejected) {
                          setSelectedProject(project.id);
                          setIsViewApplication(true);
                        }
                      }}
                    >
                      <div className="flex justify-between items-start flex-wrap gap-2">
                        {/* Project Name & ID */}
                        <div className="flex-1 relative">
                          {project.isDeleted || project.rejected ? (
                            <p className="text-sm sm:text-base font-medium text-gray-400">{project.zoho_id} - {project.name}</p>
                          ) : (
                            <a
                              href={`/app/ProjectDetails/${project.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block"
                            >
                              <div className="text-sm sm:text-base font-medium text-[#365561]">
                                {project.zoho_id} - {project.name}
                              </div>
                            </a>
                          )}

                          {/* Tooltip - Project Summary */}
                          {project.summary && (
                              <div
                                className="absolute z-10 left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 shadow-lg w-max max-w-xs pointer-events-none"
                                dangerouslySetInnerHTML={{ __html: project.summary }}
                              />
                            )}

                          {/* Rate Info */}
                          <div className="mt-1 text-xs text-gray-500">
                            {project.isDeleted || project.rejected || project.pending ? (
                              <>
                                {project.selfApplied && (<span className="text-xs text-[#365561] font-semibold px-2 py-1 bg-gray-200 rounded-full">Self Applied</span>)}
                              </>
                            ) : (
                              <>
                                <strong>Consultant Rate:</strong> {project.con_rate} |{" "}
                                <strong>EPH Rate:</strong> {project.eph_rate}
                                {project.selfApplied && (<span className="ml-2 text-xs text-[#365561] font-semibold px-2 py-1 bg-gray-200 rounded-full">Self Applied</span>)}
                              </>
                            )}
                          </div>
                        </div>

                        {/* Project Type */}
                        {project.isDeleted || project.rejected || project.pending ? (
                          <>
                            {project.proj_type === "exp" ? (
                              <div className="flex flex-col gap-2">
                                <div className="text-xs text-gray-600 text-center flex-shrink-0">
                                  <i className="fa-solid fa-phone-volume mr-1 text-sm" />
                                  Expert Call
                                </div>
                                <span>{project.isDeleted ? (<><i class="fa-solid fa-user-minus"></i> <p className="text-[9px] font-semibold">Deleted</p></>) : project.rejected ? '🚫' : project.pending ? '⏳' : null}</span>
                              </div>
                            ) : (
                              <span className="flex flex-row justify-center gap-[1px] text-rose-500">{project.isDeleted ? (<><i class="fa-solid fa-user-minus"></i> <p className="text-[9px] font-semibold">Deleted</p></>) : project.rejected ? '🚫' : project.pending ? '⏳' : null}</span>
                            )}
                          </>
                        ) : (
                          <>
                            {project.proj_type === "exp" && (
                              <div className="text-xs text-gray-600 text-center flex-shrink-0">
                                <i className="fa-solid fa-phone-volume mr-1 text-sm" />
                                Expert Call
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>

                    {/* Divider */}
                    {i !== inInterestedList.length - 1 && (
                      <hr className="mt-1 mb-1 border-t border-gray-200" />
                    )}
                  </React.Fragment>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-500">No project found.</p>
            )}

          </div>

          {/* -------------added in project list-------------- */}
          <div className="relative bg-white rounded-xl shadow p-6">
            <div
              className="absolute top-0 right-0 w-8 h-8 bg-[#365561] text-white text-xs font-bold flex items-center justify-center"
              style={{
                borderTopRightRadius: '19px',
                borderBottomLeftRadius: '50px',
              }}
            >
              <p className="text-white text-[10px] ml-1 -mt-1">EPH</p>
            </div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Added in Projects</h2>
            </div>

            {addedInProjectList?.length > 0 ? (
              <ul className="space-y-1">
                {addedInProjectList.map((project, i) => (
                  <React.Fragment key={i}>
                    <div
                      key={project.id}
                      className="p-2 rounded-md hover:bg-gray-100 transition duration-150 group"
                    >
                      <a
                        href={`/app/ProjectDetails/${project.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block no-underline"
                      >
                        <div className="flex justify-between items-start flex-wrap gap-2">
                          {/* Project ID & Name */}
                          <div className="flex-1 relative">
                            <div className="text-sm sm:text-base font-medium text-[#365561]">
                              {project.zoho_id} - {project.name}
                            </div>

                            {/* Tooltip - Project Summary */}
                            {project.summary && (
                              <div
                                className="absolute z-10 left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 shadow-lg w-max max-w-xs pointer-events-none"
                                dangerouslySetInnerHTML={{ __html: project.summary }}
                              />
                            )}
                          </div>

                          {/* Project Type (if available) */}
                          {project.proj_type === "exp" && (
                            <div className="text-xs text-[#365561] text-center flex-shrink-0">
                              <i className="fa-solid fa-phone-volume mr-1 text-sm" />
                              Expert Call
                            </div>
                          )}
                        </div>
                      </a>
                    </div>

                    {/* Divider */}
                    {i !== addedInProjectList.length - 1 && (
                      <hr className="mt-1 mb-1 border-t border-gray-200" />
                    )}
                  </React.Fragment>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-500">No project found.</p>
            )}

          </div>

          {/* ----------------Digital powerpoint list-------------- */}
          <div className="relative bg-white rounded-xl shadow p-6">
            <div
              className="absolute top-0 right-0 w-8 h-8 bg-[#365561] text-white text-xs font-bold flex items-center justify-center"
              style={{
                borderTopRightRadius: '19px',
                borderBottomLeftRadius: '50px',
              }}
            >
              <p className="text-white text-[10px] ml-1 -mt-1">EPH</p>
            </div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Created Digital PowerPoints</h2>
            </div>

            {createdDigital?.length > 0 ? (
              <ul className="space-y-1">
                {createdDigital.map((item, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="relative group p-2 rounded-md hover:bg-gray-100 transition duration-150"
                    >
                      <a
                        href={`/app/ExistingDigitalPPT/${item.projectID}/${item.expertID}/null`}
                        target="_blank"
                        rel="noreferrer"
                        className="no-underline text-[#365561] font-medium"
                      >
                        {item.pptName}
                      </a>

                      {/* Tooltip */}
                      {item.summ && (
                        <div className="absolute z-10 left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 shadow-lg w-max max-w-xs"
                          dangerouslySetInnerHTML={{ __html: item.summ }}/>
                      )}
                    </div>
                    {i !== createdDigital.length - 1 && (
                      <hr className="mt-1 mb-1 border-t border-gray-200" />
                    )}
                  </React.Fragment>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-500">No digital powerpoint found.</p>
            )}
          </div>

          {/* --------------created powerpoint list--------------- */}
          <div className="relative bg-white rounded-xl shadow p-6">
            <div
              className="absolute top-0 right-0 w-8 h-8 bg-[#365561] text-white text-xs font-bold flex items-center justify-center"
              style={{
                borderTopRightRadius: '19px',
                borderBottomLeftRadius: '50px',
              }}
            >
              <p className="text-white text-[10px] ml-1 -mt-1">EPH</p>
            </div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">Created PowerPoints</h2>
            </div>

            {createdPPTList?.some((project) => project.pptExist) ? (
              <div className="space-y-1">
                {createdPPTList.map((project, i) =>
                  project.pptExist ? (
                    <React.Fragment key={i}>
                      <div
                        key={project.id}
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <ViewExistingPPT project={project} expertName={expertName} />
                      </div>
                      {i !== createdPPTList.length - 1 && (
                        <hr className="mt-1 mb-1 border-t border-gray-200" />
                      )}
                    </React.Fragment>
                  ) : null
                )}
              </div>
            ) : (
              <p className="text-sm text-gray-500">No powerpoint found.</p>
            )}
          </div>
          
          {isViewApplication && (
            <ViewApplication 
              projectID={selectedProject}
              expertID={id}
              onClose={handleClosing}
            />
          )}
        </>
      ) : (
        <div style={{ textAlign: "center", marginTop: 0 }}>
          <img src={LoadingIcon} alt="Loading..." style={{ height: "30px" }} />
        </div>
      )}
    </>
  );
}